import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { Assets } from '@freelancer/ui/assets';
import { FontColor, FontWeight, TextSize } from '@freelancer/ui/text';
import { AvatarSize } from '@freelancer/ui/user-avatar';
import { AiConsultantSuggestedMessageComponent } from '../ai-consultant-suggested-message/ai-consultant-suggested-message.component';

@Component({
  standalone: true,
  imports: [AiConsultantSuggestedMessageComponent, CommonModule, UiModule],
  selector: 'app-ai-consultant-empty-state',
  template: `
    <fl-user-avatar
      [users]="[aiUser]"
      [disableAvatarBorder]="true"
      [disableOnlineIndicatorBorder]="true"
      [isOnline]="true"
      [size]="AvatarSize.LARGE"
      [flMarginBottom]="'small'"
    ></fl-user-avatar>
    <fl-text
      i18n="AI Consultant empty state title"
      [color]="FontColor.LIGHT"
      [weight]="FontWeight.BOLD"
      [size]="TextSize.LARGE"
      [flMarginBottom]="'small'"
    >
      Hi I'm Ava, your AI guide to supercharging your business!
    </fl-text>
    <fl-text
      i18n="AI Consultant empty state description"
      [color]="FontColor.LIGHT"
      [size]="TextSize.SMALL"
      [flMarginBottom]="'small'"
    >
      Whether you're already running a business or dreaming of starting one, I'm
      here to help turn your vision into reality using AI powered freelancers.
      Share your business goals, and together, we'll create a project that our
      talented freelancers can bid on. Let's make your vision a reality!
    </fl-text>
    <app-ai-consultant-suggested-message
      message="I have a business"
      i18n-message="Suggested message for existing business owners"
      (messageClicked)="handleMessageClicked($event)"
    ></app-ai-consultant-suggested-message>
    <app-ai-consultant-suggested-message
      message="I'm starting a business"
      i18n-message="Suggested message for new business owners"
      (messageClicked)="handleMessageClicked($event)"
    ></app-ai-consultant-suggested-message>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./ai-consultant-empty-state.component.scss'],
})
export class AiConsultantEmptyStateComponent {
  AvatarSize = AvatarSize;
  FontColor = FontColor;
  FontWeight = FontWeight;
  TextSize = TextSize;

  aiUser = {
    avatar: this.assets.getUrl('ai-consultant/ai-agent-avatar.jpg'),
    username: 'ava',
  };

  @Output() suggestedMessageClicked = new EventEmitter<string>();

  constructor(private assets: Assets) {}

  handleMessageClicked(message: string): void {
    this.suggestedMessageClicked.emit(message);
  }
}
